import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { LogoIcon } from "@tamagui/logo";
import { useRef, useState } from "react";
import { Button, Square, YStack } from "tamagui";
import { useIsIntersecting } from "./useOnIntersecting";
function AnimationsEnterDemo(props) {
  const ref = useRef(null);
  const hasIntersected = useIsIntersecting(ref, { once: true });
  const [key, setKey] = useState(0);
  if (!hasIntersected) {
    return /* @__PURE__ */ jsx(YStack, { ref });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Square,
      {
        enterStyle: {
          scale: 1.5,
          y: -10,
          opacity: 0
        },
        animation: "bouncy",
        elevation: "$4",
        size: 110,
        opacity: 1,
        scale: 1,
        y: 0,
        backgroundColor: "$pink10",
        borderRadius: "$9",
        children: props.children ?? /* @__PURE__ */ jsx(LogoIcon, { downscale: 0.75 })
      },
      key
    ),
    /* @__PURE__ */ jsx(Button, { size: "$3", marginTop: "$4", onPress: () => setKey(Math.random()), children: "Re-mount" })
  ] });
}
export {
  AnimationsEnterDemo
};
//# sourceMappingURL=AnimationsEnterDemo.js.map
